import TaskAltOutlinedIcon from "@mui/icons-material/TaskAltOutlined";
import CircleIcon from "@mui/icons-material/Circle";
import { Stack, styled, Tooltip, Typography } from "@mui/material";
import { withDefaults } from "~/common/hoc/withDefaults";

const Label = styled(Typography)<{ $filled: boolean }>(({ $filled, theme }) => ({
  color: $filled ? theme.palette.onSuccessContainer!.main : theme.palette.text.label,
  marginLeft: "4px",
  flex: 1,
}));

const Value = styled(Typography)(({ theme }) => ({
  fontWeight: "bold",
  color: theme.palette.text.secondary,
}));

export const TargetGraphTooltipEntry = styled(
  ({ isFilled, label, value, color }: { isFilled?: boolean; label: string; value: string; color?: string }) => {
    let icon;
    if (isFilled) {
      icon = <TaskAltOutlinedIcon sx={{ color: "onSuccessContainer.main" }} fontSize="small" />;
    } else {
      icon = <CircleIcon sx={{ color: color ?? "transparent" }} fontSize="small" />;
    }
    return (
      <Stack direction="row" alignItems={"center"}>
        {icon}
        <Label $filled={isFilled ?? false}>{label}</Label>
        <Value>{value}</Value>
      </Stack>
    );
  },
)<{ isFilled?: boolean; label: string; value: string }>();

export const TargetGraphTooltip = withDefaults(Tooltip, {
  variant: "rich",
  placement: "top",
  arrow: true,
  slotProps: {
    tooltip: {
      sx: {
        maxWidth: "unset",
      },
    },
  },
});

export const TargetGraphTooltipContent = styled(Stack)({
  gap: "8px",
  width: "287px",
});
